// extracted by mini-css-extract-plugin
export default {"Score":"Score_Score__VH9eU","Answered":"Score_Answered__bhvga","NotAnswered":"Score_NotAnswered__UC74v","Current":"Score_Current__DxgfA"};